import { application } from "./application"

import FancyboxController from "./fancybox_controller.js"
application.register("fancybox", FancyboxController)

import RemoteModalController from "./remote_modal_controller.js"
application.register("remote-modal", RemoteModalController)